import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/short-logo-hurst.svg")